import { useState } from "react";
import Typewriter from "./typewriter";

type Medicine = {
  drugName: string;
  drugStrength: string;
};

type ChatbotMemberMedicationProps = {
  drugs: Medicine[];
};

const ChatbotMemberMedication: React.FC<ChatbotMemberMedicationProps> = ({
  drugs,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <ul className="list-disc pl-6 text-gray-700">
      {drugs.slice(0, currentIndex + 1).map((drug, index) => (
        <li key={index} className="mb-1">
          <Typewriter
            text={`${drug.drugName} ${drug.drugStrength}`}
            onDone={() => setCurrentIndex((prev) => prev + 1)}
          />
        </li>
      ))}
    </ul>
  );
};

export default ChatbotMemberMedication;
